import { Row } from "./Row/Row";
import classnames from "classnames";

export const SummaryRow = ({
  children,
  className,
  tableDepth,
  ...rowProps
}) => (
  <Row
    {...rowProps}
    tableDepth={tableDepth}
    className={classnames("summary", className)}
    noArrow
  >
    {children}
  </Row>
);

SummaryRow.propTypes = {
  ...Row.props
};
